export default __webpack_public_path__ + "static/media/bilyana_s.5104a7f4.jpg";